// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductList_ProductList__KiSOe"};